"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryStrategyType = exports.SCIM_SYNC_STATUS = void 0;
/** Canonical {@link ScimSyncStatus} values — reference these instead of bare string literals (producer + consumers). */
exports.SCIM_SYNC_STATUS = {
    CLEAN: 'clean',
    COMPLETED_WITH_ERRORS: 'completedWithErrors',
};
var DeliveryStrategyType;
(function (DeliveryStrategyType) {
    DeliveryStrategyType["WEBHOOK"] = "WEBHOOK";
    DeliveryStrategyType["POLL"] = "POLL";
    DeliveryStrategyType["AWAIT"] = "AWAIT";
})(DeliveryStrategyType || (exports.DeliveryStrategyType = DeliveryStrategyType = {}));
